import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1xs6,
    GridItem2xs6,
    GridItem3xs6,
    GridItem7xs12,
    GridItem8xs12,
    GridItem11xs6,
} from '../../../business-components/Grid/Grid'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadraoRequired,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorValor,
    TextValidatorValorRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldNumberSelect,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import {
    grupoCoberturaSeguroVidaList
 } from '../../../business-rules/List/SeguroVida/grupoCoberturaSeguroVidaList'

import tipoCoberturaSeguroVidaList from '../../../business-rules/List/SeguroVida/tipoCoberturaSeguroVidaList'

import tipoPrazoRecebtoRendaCoberturaSeguroVidaList from '../../../business-rules/List/tipoPrazoRecebtoRendaCoberturaSeguroVidaList'

import statusCoberturaList from '../../../business-rules/List/SeguroVida/statusCoberturaList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
 } from '../../../business-components/Button/Button'

import {
    incrementaContSeguroVidaCobertura,
    processaAlteracaoSeguroVidaCoberturaTipoCoberturaSeguroVida,
} from './SeguroVidaServiceSeguroVidaCobertura'

const SeguroVidaFormSeguroVidaCobertura = ({ idSeguroVidaApolice, idReceitaMensal, integracao, values, handleChange, setFieldValue }) => {
    
    let tipoCoberturaSeguroVidaSelecionado = ''

    return (
        <FieldArray name="seguroVidaCobertura">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm
                        style={{
                            display: values.seguroVidaCobertura && values.seguroVidaCobertura.filter(seguroVidaCobertura => seguroVidaCobertura.idSeguroVidaApolice === idSeguroVidaApolice).length > 0 ? "block" : "none"
                        }}
                    >
                        {values.seguroVidaCobertura?.map((item, ind) => {
                            
                            tipoCoberturaSeguroVidaSelecionado = pesquisaList(tipoCoberturaSeguroVidaList, 
                                item.tipoCoberturaSeguroVida)

                            if (!item.dataTerminoCobertura) {

                                item.dataTerminoCobertura = null
                            }

                            return item.idSeguroVidaApolice === idSeguroVidaApolice ? (
                                <GridContainer
                                    key={ind}
                                >
                                    <GridItem2xs6>
                                        <TextFieldNumberSelect
                                            name={`seguroVidaCobertura[${ind}].grupoCoberturaSeguroVida`}
                                            label={LABEL.grupoCoberturaSeguroVida}
                                            value={item.grupoCoberturaSeguroVida === 0 ? 0 : item.grupoCoberturaSeguroVida || ''}
                                            onChange={handleChange}
                                            list={grupoCoberturaSeguroVidaList}
                                            disabled={idReceitaMensal > 0}
                                        />
                                    </GridItem2xs6>
                                    <GridItem2xs6>
                                        <TextFieldNumberSelect
                                            name={`seguroVidaCobertura[${ind}].tipoCoberturaSeguroVida`}
                                            label={LABEL.tipoCoberturaSeguroVida}
                                            value={item.tipoCoberturaSeguroVida || ''}
                                            onChange={handleChange}
                                            list={tipoCoberturaSeguroVidaList.filter(linhaTipoCoberturaSeguroVidaList => 
                                                linhaTipoCoberturaSeguroVidaList.grupoCoberturaSeguroVida === item.grupoCoberturaSeguroVida)}
                                            onBlur={processaAlteracaoSeguroVidaCoberturaTipoCoberturaSeguroVida(item)}
                                            disabled={idReceitaMensal > 0}
                                        />
                                    </GridItem2xs6>
                                    <GridItem8xs12>
                                        <GridContainer>
                                            {item.tipoCoberturaSeguroVida
                                                ?
                                                    <>
                                                        <GridItem2xs6>
                                                            <TextValidatorValorRequired
                                                                name={`seguroVidaCobertura[${ind}].valorCS`}
                                                                label={tipoCoberturaSeguroVidaSelecionado.tipoValorInformado === "CS"
                                                                    ? LABEL.valorCS
                                                                    : tipoCoberturaSeguroVidaSelecionado.tipoValorInformado === "Renda"
                                                                        ? LABEL.valorRenda
                                                                        : tipoCoberturaSeguroVidaSelecionado.tipoValorInformado === "Diaria"
                                                                            ? LABEL.valorDiaria
                                                                            : ""
                                                                }
                                                                value={item.valorCS === 0 ? 0 : item.valorCS  || ''}
                                                                onChange={handleChange}
                                                                disabled={idReceitaMensal > 0}
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6>
                                                            <TextValidatorValorRequired
                                                                name={`seguroVidaCobertura[${ind}].valorPremio`}
                                                                label={LABEL.valorPremio}
                                                                value={item.valorPremio === 0 ? 0 : item.valorPremio || ''}
                                                                onChange={handleChange}
                                                                disabled={idReceitaMensal > 0}
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display:
                                                                    tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCobertura === "S" ||
                                                                    (
                                                                        tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCoberturaOpcional === "S" &&
                                                                        item.dataTerminoCobertura
                                                                    )
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <MuiPickersUtilsProviderPadrao>
                                                                <KeyboardDatePickerPadraoRequired
                                                                    name={`seguroVidaCobertura[${ind}].dataTerminoCobertura`}
                                                                    label={LABEL.dataTerminoCobertura}
                                                                    value={item.dataTerminoCobertura}
                                                                    onChange={(date) => {
                                                                        setFieldValue(
                                                                            `seguroVidaCobertura[${ind}].dataTerminoCobertura`,
                                                                            date,
                                                                        )}
                                                                    }
                                                                    disabled={item.idReceitaMensal > 0}
                                                                />
                                                            </MuiPickersUtilsProviderPadrao>
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display:
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda === "S" ||
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda === "V"
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextFieldNumberSelectRequired
                                                                name={`seguroVidaCobertura[${ind}].tipoPrazoRecebtoRenda`}
                                                                label={LABEL.tipoPrazoRecebtoRenda}
                                                                value={item.tipoPrazoRecebtoRenda || ''}
                                                                onChange={handleChange}
                                                                list={tipoPrazoRecebtoRendaCoberturaSeguroVidaList(
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda)
                                                                }
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display: 
                                                                    tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCobertura !== "S" &&
                                                                    (
                                                                        tipoCoberturaSeguroVidaSelecionado.informaDataTerminoCoberturaOpcional !== "S" ||
                                                                        !item.dataTerminoCobertura
                                                                    ) &&
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda !== "S" &&
                                                                    tipoCoberturaSeguroVidaSelecionado.informaTipoPrazoRecebtoRenda !== "V"
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        />

                                                        <GridItem2xs6
                                                            style={{
                                                                display: 
                                                                    tipoCoberturaSeguroVidaSelecionado.informaCSSobrevivencia === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextValidatorValorRequired
                                                                name={`seguroVidaCobertura[${ind}].valorCSSobrevivencia`}
                                                                label={LABEL.valorCSSobrevivencia}
                                                                value={item.valorCSSobrevivencia || ''}
                                                                onChange={handleChange}
                                                            />
                                                        </GridItem2xs6>

                                                        <GridItem2xs6
                                                            style={{
                                                                display: 
                                                                    tipoCoberturaSeguroVidaSelecionado.informaCSSobrevivencia !== "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        />

                                                        <GridItem3xs6>
                                                            <TextFieldNumberSelect
                                                                name={`seguroVidaCobertura[${ind}].statusCobertura`}
                                                                label={LABEL.statusCobertura}
                                                                value={item.statusCobertura || ''}
                                                                onChange={handleChange}
                                                                list={statusCoberturaList}
                                                                disabled={idReceitaMensal > 0}
                                                            />
                                                        </GridItem3xs6>
                                                    </>
                                                :
                                                    <GridItem11xs6/>
                                            }

                                            <GridItem1xs6>
                                                <IconButtonClearEntradaDados
                                                    onClick={() =>
                                                        arrayHelpers.remove(ind)
                                                    }
                                                    style={{
                                                        display:
                                                            !idReceitaMensal
                                                                ? "block"
                                                                : "none"
                                                    }}
                                                />
                                            </GridItem1xs6>
                                        </GridContainer>

                                        {item.tipoCoberturaSeguroVida && integracao === 'S' && (
                                            <>
                                                <GridContainer>
                                                    <GridItem2xs6>
                                                        <TextValidatorValor
                                                            name={`seguroVidaCobertura[${ind}].valorPremioLiquido`}
                                                            label={LABEL.valorPremioLiquido}
                                                            value={item.valorPremioLiquido === 0 ? 0 : item.valorPremioLiquido || ''}
                                                            onChange={handleChange}
                                                            disabled={idReceitaMensal > 0}
                                                        />
                                                    </GridItem2xs6>
                                                    <GridItem2xs6>
                                                        <TextValidatorValor
                                                            name={`seguroVidaCobertura[${ind}].valorIof`}
                                                            label={LABEL.valorIof}
                                                            value={item.valorIof === 0 ? 0 : item.valorIof || ''}
                                                            onChange={handleChange}
                                                            disabled={idReceitaMensal > 0}
                                                        />
                                                    </GridItem2xs6>
                                                    <GridItem7xs12>
                                                        <TextValidatorText
                                                            name={`seguroVidaCobertura[${ind}].descricaoCobertura`}
                                                            label={LABEL.descricaoCobertura}
                                                            value={item.descricaoCobertura || ''}
                                                            onChange={handleChange}
                                                            disabled={idReceitaMensal > 0}
                                                            tamMax={TAMMAX.descricaoCobertura}
                                                        />
                                                    </GridItem7xs12>
                                                </GridContainer>

                                                <GridContainer>
                                                    {item.numeroCobertura && (
                                                        <GridItem2xs6>
                                                            <TextValidatorNumber
                                                                name={`seguroVidaCobertura[${ind}].numeroCobertura`}
                                                                label={LABEL.numeroCobertura}
                                                                value={item.numeroCobertura === 0 ? 0 : item.numeroCobertura || ''}
                                                                onChange={handleChange}
                                                                disabled={idReceitaMensal > 0}
                                                                numMin={NUMMIN.numeroCobertura}
                                                                numMax={NUMMAX.numeroCobertura}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                    {item.codigoCobertura && (
                                                        <GridItem2xs6>
                                                            <TextValidatorText
                                                                name={`seguroVidaCobertura[${ind}].codigoCobertura`}
                                                                label={LABEL.codigoCobertura}
                                                                value={item.codigoCobertura || ''}
                                                                onChange={handleChange}
                                                                disabled={idReceitaMensal > 0}
                                                                tamMax={TAMMAX.codigoCobertura}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                    {item.classeAjusteRisco && (
                                                        <GridItem2xs6>
                                                            <TextValidatorText
                                                                name={`seguroVidaCobertura[${ind}].classeAjusteRisco`}
                                                                label={LABEL.classeAjusteRisco}
                                                                value={item.classeAjusteRisco || ''}
                                                                onChange={handleChange}
                                                                disabled={idReceitaMensal > 0}
                                                                tamMax={TAMMAX.classeAjusteRisco}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                    {item.valorPremioExtra > 0 && (
                                                        <GridItem2xs6>
                                                            <TextValidatorValor
                                                                name={`seguroVidaCobertura[${ind}].valorPremioExtra`}
                                                                label={LABEL.valorPremioExtra}
                                                                value={item.valorPremioExtra === 0 ? 0 : item.valorPremioExtra || ''}
                                                                onChange={handleChange}
                                                                disabled={idReceitaMensal > 0}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                    {item.duracaoPremioExtra > 0 && (
                                                        <GridItem1xs6>
                                                            <TextValidatorNumber
                                                                name={`seguroVidaCobertura[${ind}].duracaoPremioExtra`}
                                                                label={LABEL.duracaoPremioExtra}
                                                                value={item.duracaoPremioExtra === 0 ? 0 : item.duracaoPremioExtra || ''}
                                                                onChange={handleChange}
                                                                numMin={NUMMIN.duracaoPremioExtra}
                                                                numMax={NUMMAX.duracaoPremioExtra}
                                                                disabled={idReceitaMensal > 0}
                                                            />
                                                        </GridItem1xs6>
                                                    )}
                                                    {item.valorRendaMensal && (
                                                        <GridItem2xs6>
                                                            <TextValidatorValor
                                                                name={`seguroVidaCobertura[${ind}].valorRendaMensal`}
                                                                label={LABEL.valorRendaMensal}
                                                                value={item.valorRendaMensal === 0 ? 0 : item.valorRendaMensal || ''}
                                                                onChange={handleChange}
                                                                disabled={idReceitaMensal > 0}
                                                            />
                                                        </GridItem2xs6>
                                                    )}
                                                </GridContainer>
                                            </>
                                        )}
                                    </GridItem8xs12>
                                </GridContainer>
                            )
                            :
                            (
                                <DivForm
                                    key={ind}
                                />
                            )
                        })}
                    </DivForm>

                    {!idReceitaMensal
                        ?
                            <ButtonIncluirLinha
                                label={LABEL.buttonIncluirSeguroVidaCobertura} 
                                onClick={() =>
                                    {
                                        incrementaContSeguroVidaCobertura(values)
                                        arrayHelpers.push({
                                            id: values.contSeguroVidaCobertura,
                                            idSeguroVidaApolice: idSeguroVidaApolice,
                                        })
                                    }
                                }
                            />
                        :
                            ''
                    }
                </DivForm>
            )}
        </FieldArray>
    )
}

export default SeguroVidaFormSeguroVidaCobertura